<div class="menu-container">
  <div class="dealer-container" [class.hide]="showLoggerPanel">
    <app-menu-card
      *ngFor="let dealer of dealers; trackBy: trackByDealer"
      [mainDealer]="dealers[0]"
      [table]="dealer"
      [isLoggerPage]="true"
      [onClickLoggerPage]="updateDealerTable.bind(this)"
    ></app-menu-card>
  </div>

  <app-logger-panel
    [class.hide]="!showLoggerPanel"
    [dealerId]="selectedDealerId"
  ></app-logger-panel>
</div>
<app-live-messages
  class="logger-live-messages"
  [messages]="messages"
  [type]="liveMessageTypeEnum.CLASSIC"
  [isAdmin]="true"
></app-live-messages>
